import { useState, useEffect } from 'react';
import BottomSheet from '../BottomSheet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faInfoCircle, faDice } from '@fortawesome/free-solid-svg-icons';
import { getRandomWord } from '../../data/jewishWords';

export default function WordDetailModal({ isOpen, onClose, word }) {
  const [randomWord, setRandomWord] = useState(null);

  // Reset random word when modal closes
  useEffect(() => {
    if (!isOpen) {
      setRandomWord(null);
    }
  }, [isOpen]);

  const handleRandomWord = () => {
    setRandomWord(getRandomWord());
  };

  // Use word as the main word, or randomWord if user clicked random
  const currentWord = randomWord || word;

  if (!word) return null;

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title="Hebrew Word of the Day"
    >
      <div className="p-6 space-y-6">
        <div className="text-center">
          <div className="text-7xl font-serif text-primary mb-4" dir="rtl">
            {currentWord.hebrew}
          </div>
          
          <h2 className="text-2xl font-bold text-text-primary mb-2">
            {currentWord.transliteration}
          </h2>
          
          <p className="text-lg text-text-secondary italic mb-6">
            {currentWord.meaning}
          </p>

          {currentWord.example && (
            <div className="bg-primary/5 rounded-xl p-5 text-left">
              <div className="flex items-center gap-2 mb-2">
                <FontAwesomeIcon icon={faInfoCircle} className="text-primary" />
                <h3 className="font-bold text-text-primary">Example</h3>
              </div>
              <p className="text-sm text-text-secondary leading-relaxed italic">
                "{currentWord.example}"
              </p>
            </div>
          )}

          {currentWord.category && (
            <div className="bg-white rounded-xl border border-border p-5 text-left mt-4">
              <div className="flex items-center gap-2 mb-2">
                <FontAwesomeIcon icon={faBook} className="text-text-secondary" />
                <h3 className="font-bold text-text-primary">Category</h3>
              </div>
              <p className="text-sm text-text-secondary leading-relaxed capitalize">
                {currentWord.category}
              </p>
            </div>
          )}
        </div>

        <div className="flex gap-3">
          <button
            onClick={handleRandomWord}
            className="flex-1 px-4 py-3 bg-surface hover:bg-[#F0F0F0] rounded-xl font-semibold text-text-primary transition-colors flex items-center justify-center gap-2 touch-target active:scale-95"
          >
            <FontAwesomeIcon icon={faDice} />
            <span>Random Word</span>
          </button>
          <button
            onClick={onClose}
            className="flex-1 px-4 py-3 bg-primary text-white rounded-xl font-semibold hover:bg-primary-dark transition-colors touch-target active:scale-95"
          >
            Close
          </button>
        </div>
      </div>
    </BottomSheet>
  );
}

